import React from "react";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";
import ListItemAvatar from "@mui/material/ListItemAvatar";
import Avatar from "@mui/material/Avatar";
import GridOnIcon from "@mui/icons-material/GridOn";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import PlayArrowIcon from "@mui/icons-material/PlayArrow";
import StopIcon from "@mui/icons-material/Stop";
import ModeEditIcon from "@mui/icons-material/ModeEdit";
import EventRepeatIcon from "@mui/icons-material/EventRepeat";
import { ExistingIntervalPreviewProps } from "./ExistingIntervalPreview";

const ExistingInterval = (props: ExistingIntervalPreviewProps) => {
  return (
    <div>
      <Box
        sx={{
          width: "99%",
          flexGrow: 1,
          marginLeft: "auto",
          marginRight: "auto",
          marginTop: "15px",
          border: "1pt solid #ebeded",
          borderRadius: "10px 10px",
          paddingBottom: "20px",
        }}
      >
        {!props.fromIntervalSet && (
          <h2 style={{ paddingTop: "10px", paddingLeft: "20px" }}>
            {props.interval.name} {"(ID: " + props.interval.id + ")"}
          </h2>
        )}
        <Grid container spacing={1}>
          <Grid item xs={6}>
            <List
              sx={{
                width: "100%",
                maxWidth: 360,
                bgcolor: "background.paper",
              }}
            >
              <ListItem>
                <ListItemAvatar>
                  <Avatar>
                    <GridOnIcon />
                  </Avatar>
                </ListItemAvatar>
                <ListItemText
                  primary="Interval Set"
                  secondary={props.interval.interval_set_id || "None"}
                />
              </ListItem>
              <ListItem>
                <ListItemAvatar>
                  <Avatar>
                    <PlayArrowIcon />
                  </Avatar>
                </ListItemAvatar>
                <ListItemText
                  primary="Start Day"
                  secondary={props.interval.start_day || "0"}
                />
              </ListItem>
              <ListItem>
                <ListItemAvatar>
                  <Avatar>
                    <StopIcon />
                  </Avatar>
                </ListItemAvatar>
                <ListItemText
                  primary="End Day"
                  secondary={props.interval.end_day || "0"}
                />
              </ListItem>
            </List>
          </Grid>

          <Grid item xs={6}>
            <List
              sx={{
                width: "100%",
                maxWidth: 360,
                bgcolor: "background.paper",
              }}
            >
              <ListItem>
                <ListItemAvatar>
                  <Avatar>
                    <CalendarMonthIcon />
                  </Avatar>
                </ListItemAvatar>
                <ListItemText
                  primary="Communication Set"
                  secondary={props.interval.communication_set_id || "None"}
                />
              </ListItem>
              <ListItem>
                <ListItemAvatar>
                  <Avatar>
                    <EventRepeatIcon />
                  </Avatar>
                </ListItemAvatar>
                <ListItemText primary="Recurrence" secondary={"None"} />
              </ListItem>
              <ListItem>
                <ListItemAvatar>
                  <Avatar>
                    <ModeEditIcon />
                  </Avatar>
                </ListItemAvatar>
                <ListItemText
                  primary="Last Modified"
                  secondary={props.interval.modified}
                />
              </ListItem>
            </List>
          </Grid>
        </Grid>
      </Box>
    </div>
  );
};

export default ExistingInterval;
